import React from 'react';
import classNames from 'classnames';
import styles from './sections.module.scss';

const CtaFooterSection = ({
  background,
  colors,
  showSubtitle = true,
  onViewOpportunities,
  onContact,
  mobileLayout = false
}) => (
  <section
    className={classNames(styles.ctaFooter, mobileLayout && styles.ctaFooterMobile)}
    style={{ background, color: '#fff' }}
  >
    <div className={styles.container}>
      <h2 className={styles.ctaHeading}>
        Ready to Take Your Future
        <br />
        <span className={styles.accent}>to the Next Level?</span>
      </h2>
      {showSubtitle && (
        <p className={styles.ctaSubtitle}>
          Build something that&apos;s truly yours, with the team and resources to make it thrive.
        </p>
      )}
      <div className={styles.ctaActions}>
        <button
          type="button"
          className={styles.btnPrimary}
          style={{ background: colors.accent }}
          onClick={onViewOpportunities}
        >
          VIEW OPPORTUNITIES
        </button>
        <button type="button" className={styles.btnOutlineWhite} onClick={onContact}>
          HAVE QUESTIONS?
        </button>
      </div>
    </div>
  </section>
);

export default CtaFooterSection;
